/*
 * Module for Calculation Details popup on Death Benefit Setup wizard's Calculation Results step
*/
rs.module("participant/benefit/setup/death/wizard/calculationdetails",

    [],

    function () {

        var _jsSelectors;
        var _cssClasses;
        var _backendUrls;
        var _benefitClaimKey;
        var _popup;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls, benefitClaimKey) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _backendUrls = backendUrls;
            _benefitClaimKey = benefitClaimKey;

            _popup = $.js(_jsSelectors.popup);

            // hookup lookup Calculation Details link click event
            $.js(_jsSelectors.calculationDetailsLink).click(_showCalculationDetailsPopup);
        }

        //
        // Show the Calculation Details popup with Tabs
        //
        function _showCalculationDetailsPopup() {

            $.get(_backendUrls.getCalculationDetailsTabs,
                {
                    benefitClaimKey: _benefitClaimKey
                })
                .done(function (result) {
    
                    // display results (tabs) inside the popup
                    _popup.js(_jsSelectors.popupContent).html(result);

                    // widen the popup for large content display
                    _popup.js(_jsSelectors.modalContent).addClass(_cssClasses.widePopup);

                    // show the popup 
                    _popup.modal("show");
                });
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);